import * as t from "io-ts";
import { ChecksumAddress } from "./checksum-address";

export const StaticMarket_3_0_0 = t.type({
  id: ChecksumAddress,
  archived: t.boolean,
  marketAssets: t.array(
    t.type({
      inputToken: t.type({
        id: ChecksumAddress,
        name: t.string,
        symbol: t.string,
        decimals: t.number,
      }),
      sToken: t.type({ id: ChecksumAddress }),
      spToken: t.type({ id: ChecksumAddress }),
      dToken: t.type({ id: ChecksumAddress }),
    })
  ),
});

/**
 * @deprecated use `StaticMarket` instead
 */
export type StaticMarket_3_0_0 = t.TypeOf<typeof StaticMarket_3_0_0>;

/**
 * @deprecated use `StaticMarket` instead
 */
export const StaticMarkets_3_0_0 = t.array(StaticMarket_3_0_0);
export type StaticMarkets_3_0_0 = t.TypeOf<typeof StaticMarkets_3_0_0>;

/**
 * @deprecated use `StaticMarket` instead
 */
export type StaticMarketAsset_3_0_0 =
  StaticMarket_3_0_0["marketAssets"][number]["inputToken"];

/**
 * @deprecated use `StaticMarket` instead
 */
export const StaticMarketLegacy = StaticMarket_3_0_0;
export type StaticMarketLegacy = StaticMarket_3_0_0;

/**
 * @deprecated use `StaticMarket` instead
 */
export const StaticMarketsLegacy = StaticMarkets_3_0_0;
export type StaticMarketsLegacy = StaticMarkets_3_0_0;

/**
 * @deprecated use `StaticMarket` instead
 */
export type StaticMarketAssetLegacy = StaticMarketAsset_3_0_0;
